import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, renderList as _renderList, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "control-wrapper" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "panel-button-area" }
const _hoisted_4 = { class: "control-item-detail-row" }
const _hoisted_5 = {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", {
  value: "480p",
  selected: ""
}, " 480p ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  value: "720p",
  selected: ""
}, " 720p ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", {
  value: "1080p",
  selected: ""
}, " 1080p ", -1)
const _hoisted_12 = {
  value: "",
  selected: "",
  disabled: "",
  hidden: ""
}
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 1,
  class: "panel-hangup"
}

import { TUICallKitServer } from '../index';
import { onMounted, ref } from 'vue';
import ControlPanelItem from './ControlPanelItem.vue';
import { profile, remoteList, changeRemoteList, callType, status, t, dialingInfo } from '../store';
import { STATUS, CALL_TYPE_STRING } from '../constants'
import RejectSVG from '../icons/reject.vue';
import AcceptAudioSVG from '../icons/acceptAudio.vue';
import AcceptVideoSVG from '../icons/acceptVideo.vue';
import AddSVG from '../icons/add.vue';
import CameraSVG from '../icons/camera.vue';
import MicrophoneSVG from '../icons/microphone.vue';
import SwitchSVG from '../icons/switch.vue';
import HangupSVG from '../icons/hangup.vue'
import MicrophoneClosedBigSVG from '../icons/microphoneClosedBig.vue';
import CameraClosedBigSVG from '../icons/cameraClosedBig.vue';
import { isMobile } from '../utils';
import "../style.css";


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlPanel',
  setup(__props) {

const cameraList = ref<any>([]);
const microphoneList = ref<any>([]);
const currentCamera = ref<string>("");
const currentMicrophone = ref("");
const currentVideoQuality = ref("");

const openCameraDetail = ref<boolean>(false);
const openMicrophoneDetail = ref<boolean>(false);

const freshDeviceList = async () => {
  cameraList.value = await TUICallKitServer.getDeviceList('camera');
  microphoneList.value = await TUICallKitServer.getDeviceList('microphones');
}

onMounted(() => {
  freshDeviceList();
  document.documentElement.addEventListener('click', (e) => {
    openCameraDetail.value = false;
    openMicrophoneDetail.value = false;
  });
});

const hangup = () => {
  TUICallKitServer.hangup();
}
function switchCameraDevice() {
  TUICallKitServer.switchDevice("video", currentCamera.value);
  openCameraDetail.value = false;
}

const switchMicrophoneDevice = () => {
  TUICallKitServer.switchDevice("audio", currentMicrophone.value);
  openMicrophoneDetail.value = false;
};

const toggleCamera = async () => {
  if (profile.value?.camera) {
    await TUICallKitServer.closeCamera();
  } else {
    await TUICallKitServer.openCamera("local");
  }
}

const toggleMicrophone = async () => {
  if (profile.value?.microphone) {
    await TUICallKitServer.closeMicrophone();
  } else {
    await TUICallKitServer.openMicrophone();
  }
}

const setVideoQuality = async () => {
  await TUICallKitServer.setVideoQuality(currentVideoQuality.value);
}

const switchCallMediaType = async () => {
  await TUICallKitServer.switchCallMediaType();
}

function addPerson_debug() {
  changeRemoteList([...remoteList.value, {
    userID: `qerTest${remoteList.value.length}`,
    isEntered: false,
    microphone: true,
    camera: true,
  }])
}

function accept() {
  TUICallKitServer.accept();
}

function reject() {
  TUICallKitServer.reject();
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(isMobile) && _unref(status) !== _unref(STATUS).CALLING_C2C_AUDIO)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(dialingInfo)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_unref(status) === _unref(STATUS).BE_INVITED)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(ControlPanelItem, {
              action: reject,
              isMobile: _unref(isMobile),
              size: _unref(isMobile) ? 'medium' : 'small'
            }, {
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('reject')), 1)
              ]),
              icon: _withCtx(() => [
                _createVNode(RejectSVG)
              ]),
              _: 1
            }, 8, ["isMobile", "size"]),
            _createVNode(ControlPanelItem, {
              action: accept,
              isMobile: _unref(isMobile),
              size: _unref(isMobile) ? 'medium' : 'small'
            }, {
              text: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('accept')), 1)
              ]),
              icon: _withCtx(() => [
                (_unref(callType) === _unref(CALL_TYPE_STRING).AUDIO)
                  ? (_openBlock(), _createBlock(AcceptAudioSVG, { key: 0 }))
                  : (_unref(callType) === _unref(CALL_TYPE_STRING).VIDEO)
                    ? (_openBlock(), _createBlock(AcceptVideoSVG, { key: 1 }))
                    : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["isMobile", "size"])
          ], 64))
        : (_unref(status) !== 'idle')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(callType) === _unref(CALL_TYPE_STRING).VIDEO)
                ? (_openBlock(), _createBlock(ControlPanelItem, {
                    key: 0,
                    action: toggleCamera,
                    hasDetail: !_unref(isMobile),
                    isMobile: _unref(isMobile),
                    size: _unref(isMobile) ? 'medium' : 'small'
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(profile)?.camera ? _unref(t)('camera-opened') : _unref(t)('camera-closed')), 1)
                    ]),
                    icon: _withCtx(() => [
                      (_unref(profile)?.camera)
                        ? (_openBlock(), _createBlock(CameraSVG, { key: 0 }))
                        : _createCommentVNode("", true),
                      (!_unref(profile)?.camera)
                        ? (_openBlock(), _createBlock(CameraClosedBigSVG, { key: 1 }))
                        : _createCommentVNode("", true)
                    ]),
                    detail: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, _toDisplayString(_unref(t)('camera')), 1),
                        _withDirectives(_createElementVNode("select", {
                          class: "device-select",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentCamera).value = $event)),
                          onChange: switchCameraDevice
                        }, [
                          _createElementVNode("option", _hoisted_5, _toDisplayString(cameraList.value && cameraList.value[0]?.label), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cameraList.value, (camera) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: camera.deviceId,
                              key: camera.deviceId
                            }, _toDisplayString(camera.label), 9, _hoisted_6))
                          }), 128))
                        ], 544), [
                          [_vModelSelect, currentCamera.value]
                        ])
                      ]),
                      (_unref(status) === _unref(STATUS).DIALING_C2C)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createElementVNode("div", null, _toDisplayString(_unref(t)('image-resolution')), 1),
                            _withDirectives(_createElementVNode("select", {
                              class: "device-select",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentVideoQuality).value = $event)),
                              onChange: setVideoQuality
                            }, [
                              _createElementVNode("option", _hoisted_8, _toDisplayString(_unref(t)('default-image-resolution')), 1),
                              _hoisted_9,
                              _hoisted_10,
                              _hoisted_11
                            ], 544), [
                              [_vModelSelect, currentVideoQuality.value]
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["hasDetail", "isMobile", "size"]))
                : _createCommentVNode("", true),
              _createVNode(ControlPanelItem, {
                action: toggleMicrophone,
                hasDetail: !_unref(isMobile),
                isMobile: _unref(isMobile),
                size: _unref(isMobile) ? 'medium' : 'small'
              }, {
                text: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(profile)?.microphone ? _unref(t)('microphone-opened') : _unref(t)('microphone-closed')), 1)
                ]),
                icon: _withCtx(() => [
                  (_unref(profile)?.microphone)
                    ? (_openBlock(), _createBlock(MicrophoneSVG, { key: 0 }))
                    : _createCommentVNode("", true),
                  (!_unref(profile)?.microphone)
                    ? (_openBlock(), _createBlock(MicrophoneClosedBigSVG, { key: 1 }))
                    : _createCommentVNode("", true)
                ]),
                detail: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createTextVNode(_toDisplayString(_unref(t)('microphone')) + " ", 1),
                    _withDirectives(_createElementVNode("select", {
                      class: "device-select",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((currentMicrophone).value = $event)),
                      onChange: switchMicrophoneDevice
                    }, [
                      _createElementVNode("option", _hoisted_12, _toDisplayString(microphoneList.value && microphoneList.value[0]?.label), 1),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(microphoneList.value, (microphone) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: microphone.deviceId,
                          key: microphone.deviceId
                        }, _toDisplayString(microphone.label), 9, _hoisted_13))
                      }), 128))
                    ], 544), [
                      [_vModelSelect, currentMicrophone.value]
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["hasDetail", "isMobile", "size"]),
              false
                ? (_openBlock(), _createBlock(ControlPanelItem, {
                    key: 1,
                    action: addPerson_debug
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('invited-person')), 1)
                    ]),
                    icon: _withCtx(() => [
                      _createVNode(AddSVG)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_unref(status) === 'calling-c2c-video')
                ? _withDirectives((_openBlock(), _createBlock(ControlPanelItem, {
                    key: 2,
                    action: switchCallMediaType
                  }, {
                    text: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('video-to-audio')), 1)
                    ]),
                    icon: _withCtx(() => [
                      _createVNode(SwitchSVG)
                    ]),
                    _: 1
                  }, 512)), [
                    [_vShow, !_unref(isMobile)]
                  ])
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(ControlPanelItem, { action: hangup }, {
                text: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(isMobile) ? '' : _unref(t)('hangup')), 1)
                ]),
                icon: _withCtx(() => [
                  _createVNode(HangupSVG)
                ]),
                _: 1
              }, 512), [
                [_vShow, !_unref(isMobile)]
              ])
            ], 64))
          : _createCommentVNode("", true)
    ]),
    (_unref(status) !== _unref(STATUS).IDLE && _unref(status) !== _unref(STATUS).BE_INVITED)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _withDirectives(_createVNode(ControlPanelItem, {
            action: hangup,
            size: _unref(isMobile) ? 'large' : 'small'
          }, {
            text: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(isMobile) ? '' : _unref(t)('hangup')), 1)
            ]),
            icon: _withCtx(() => [
              _createVNode(HangupSVG)
            ]),
            _: 1
          }, 8, ["size"]), [
            [_vShow, _unref(isMobile)]
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})